import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Alert, AlertsService } from 'src/app/providers/services/alerts.service';

@Component({
    selector: 'app-alerts-view',
    templateUrl: './alerts-view.component.html',
    styleUrls: ['./alerts-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AlertsViewComponent implements OnInit, OnDestroy {

  alerts: Alert[];
  private alertsSubscription: Subscription;

  constructor(
    private alertsService: AlertsService
  ) { }

  ngOnInit() {
    this.alertsSubscription = this.alertsService.alerts$.subscribe((alerts: Alert[]) => {
      this.alerts = alerts;
    });
  }

  ngOnDestroy() {
    if (this.alertsSubscription) { this.alertsSubscription.unsubscribe(); }
  }
}
